export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-strikethrough-d11473f4d68b63527df32a2764a21e36.svg";